import React, { useState } from "react";
import { useEffect } from "react";
import { showtoast } from "../Utilities/Utilities";

const apiBaseURL = process.env.REACT_APP_API_URL || `${window.location.origin}`;

export const PaymentInfo = (props) => {
  const {
    finalCart,
    allCartSummary,
    handleMakePayment,
    activePaymentBtn,
    setIsModalVisible,
  } = props;

  const [cartSummary, setCartSummary] = useState(allCartSummary);
  const [myFinalCart, setMyFinalCart] = useState(finalCart);
  const [additionalInfo, setAdditionalInfo] = useState("");

  const [showAdditionalInfo, setShowAdditionalInfo] = useState(false);
  const [finalDiscountPerc, setFinalDiscountPerc] = useState(null);
  const [minVoucherCriteria, setMinVoucherCriteria] = useState(false);

  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.screen.width >= 1280) {
        if (window.scrollY > 50) {
          // Threshold for adding class
          setIsScrolled(true);
        } else {
          setIsScrolled(false);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const toggleAdditionalInfo = () => {
    setShowAdditionalInfo(!showAdditionalInfo);
  };

  // Function to handle increment
  const handleIncrement = (e, item, itemID) => {
    e.preventDefault();
    if (itemID > 0) {
      if (myFinalCart.vouchers <= 20) {
        let MyCartSummary = [...cartSummary];
        const index = MyCartSummary.findIndex((rw) => rw.planID === itemID);

        if (index !== -1) {
          MyCartSummary[index] = {
            ...MyCartSummary[index],
            quantity: item + 5,
          };

          const request = {
            planID: MyCartSummary[index].planID,
            voucherCount: MyCartSummary[index].quantity,
          };
          getBulkPurchaseDiscountedPrice(request, MyCartSummary);
        }
      } else {
        setIsModalVisible(true);
      }
    }
  };

  // Function to handle decrement
  const handleDecrement = (e, item, itemID) => {
    e.preventDefault();

    if (itemID > 0) {
      if (myFinalCart.vouchers >= 15) {
        let MyCartSummary = [...cartSummary];
        const index = MyCartSummary.findIndex((rw) => rw.planID === itemID);

        if (index !== -1) {
          MyCartSummary[index] = {
            ...MyCartSummary[index],
            quantity: item > 0 ? item - 5 : 0,
          };

          const request = {
            planID: MyCartSummary[index].planID,
            voucherCount: MyCartSummary[index].quantity,
          };
          getBulkPurchaseDiscountedPrice(request, MyCartSummary);
        }
      } else {
        const { quantity } = cartSummary.find((item) => item.planID === itemID);

        if (quantity && quantity !== 0) {
          showtoast("error", "Minimum 10 vouchers are allowed.");
          return;
        }
      }
    }
  };

  const getBulkPurchaseDiscountedPrice = (req, cartSummaryData) => {
    const request =
      cartSummaryData &&
      cartSummaryData.length > 0 &&
      cartSummaryData.map((item) => {
        const data = {
          SubscriptionPlanID: item.planID,
          Quantity: item.quantity,
          PlanAmount: item.subscriptionAmount,
        };
        return data;
      });

    fetch(
      `${apiBaseURL}/api/FriendAndFamily/GetWatchoFFPlanAggregateDiscountInfo`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(request),
      },
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((resultInfo) => {
        if (resultInfo && resultInfo.resultStatus === "Success") {
          handleFinalCart(resultInfo.result);
          setCartSummary(resultInfo.result);
          updateAdditionlInfo(resultInfo.result);
        } else if (resultInfo && resultInfo.resultStatus !== "Success") {
          showtoast("error", resultInfo.resultMessage);
        }
      })
      .catch((err) => {
        console.error("Error calling planPrice API:", err);
      });
  };

  const handleFinalCart = (MyCartSummaryData) => {
    let totalVoucher = 0;
    let desc = "";
    let totalPrice = 0;
    let totalDiscount = 0;
    let totalAmount = 0;

    if (MyCartSummaryData.length > 0) {
      MyCartSummaryData.forEach((data) => {
        totalVoucher += data.quantity;
        desc = desc.length > 0 ? desc + " + " : "";
        desc =
          desc +
          `${data.quantity} ${data.subscriptionPlanName} ${data.discountPercentage > 0 ? `(${data.discountPercentage}% off)` : ""}`;
        totalPrice = data.finalAggrTotal;
        totalDiscount = data.finalAggrTotalDiscount;
        totalAmount = data.totalAggrWithoutDiscount;
      });
      let finalCartsummary = {
        vouchers: totalVoucher,
        cartDesc: desc,
        cartValue: totalPrice,
        totalDiscount: totalDiscount,
        totalAmount: totalAmount,
      };
      setMyFinalCart({ ...myFinalCart, ...finalCartsummary });
    }
  };

  const updateAdditionlInfo = (MyCartSummary) => {
    let addInfo = "";
    MyCartSummary &&
      MyCartSummary.forEach((data) => {
        addInfo = addInfo.length > 0 ? addInfo + " + " : "";
        addInfo += `₹${data.subscriptionAmount} x ${data.quantity}`;
      });
    setAdditionalInfo(addInfo);
  };

  useEffect(() => {
    if (additionalInfo.length <= 0) {
      updateAdditionlInfo(allCartSummary);
    }

    if (
      myFinalCart &&
      myFinalCart.vouchers >= 10 &&
      myFinalCart &&
      myFinalCart.vouchers <= 25
    ) {
      setMinVoucherCriteria(true);
    } else {
      setMinVoucherCriteria(false);
    }

    let discountPer = myFinalCart
      ? (myFinalCart.totalDiscount * 100) / myFinalCart.totalAmount
      : 0;
    discountPer = Math.round(discountPer);
    setFinalDiscountPerc(discountPer);
  }, [
    cartSummary,
    myFinalCart,
    additionalInfo,
    allCartSummary,
    finalDiscountPerc,
  ]);

  return (
    <div
      className={`col-lg-5 friendsFamily order-summary ${isScrolled ? "scrolled" : ""}`}
    >
      <h5 className="Order-Summary-new">Order Summary</h5>
      <p className="orderSummaryCaption">
        You are paying for the selected plan(s) coupon vouchers.
      </p>
      <hr className="my-line" />
      <ul className="list-unstyled">
        {cartSummary &&
          cartSummary.length > 0 &&
          cartSummary.map((item, idx) => (
            <li key={idx} className="d-flex justify-content-between">
              <span className="watcho-mex"> {item.subscriptionPlanName} </span>
              <div className="flx-div">
                <span
                  className="watcho-mex sub-img small"
                  onClick={(e) =>
                    handleDecrement(e, item.quantity, item.planID)
                  }
                >
                  <img
                    src="/Images/subb-img.png"
                    alt="Subtract"
                    className="img-fluid sib-img"
                  />
                </span>
                <div className="watcho-mex-ten">{item.quantity}</div>
                <span
                  className="watcho-mex add-img small"
                  onClick={(e) =>
                    handleIncrement(e, item.quantity, item.planID)
                  }
                >
                  <img
                    src="/Images/add-img.png"
                    alt="Add"
                    className="img-fluid sib-img"
                  />
                </span>
              </div>
            </li>
          ))}
      </ul>
      <hr className="my-line" />
      <div className="mt-3">
        <h5 className="d-flex justify-content-between">
          No. of Vouchers{" "}
          <span id="total-vouchers" style={{ paddingRight: "29px" }}>
            {myFinalCart && myFinalCart.vouchers}
          </span>
        </h5>

        <p className="payment-summary">Payment Summary</p>
        <hr className="my-line" />
        <div className="d-flex justify-content-between mb-2">
          <span className="watcho-mex">Package Amount</span>
          <span className="watcho-mex">
            ₹ {myFinalCart && myFinalCart.totalAmount}
          </span>
        </div>

        <div style={{ position: "relative" }} onClick={toggleAdditionalInfo}>
          <img
            src="/Images/info-icon.svg"
            alt="My Logo"
            className="img-fluid info-icon"
          />
        </div>

        <>
          {showAdditionalInfo && (
            <div style={{ position: "relative" }}>
              <span className="rate-killa">{additionalInfo}</span>
            </div>
          )}
        </>
        <div className="d-flex justify-content-between">
          <span className="watcho-mex">
            {myFinalCart && myFinalCart.totalDiscount > 0
              ? finalDiscountPerc
              : 0}
            % Discount
          </span>
          <span className="watcho-mex">
            -₹ {myFinalCart && myFinalCart.totalDiscount}
          </span>
        </div>
        <hr className="my-line" />
        <div className="d-flex justify-content-between">
          <span className="tottal-ayment">Total Payment</span>
          <span className="tottal-ayment">
            ₹ {myFinalCart && myFinalCart.cartValue}
          </span>
        </div>
        <hr className="my-line" />
      </div>
      <div className="paymentBtnWrapper">
        {myFinalCart &&
        myFinalCart.cartValue > 0 &&
        activePaymentBtn &&
        minVoucherCriteria ? (
          <button
            className="bttn-make-payment"
            onClick={() => handleMakePayment(cartSummary, myFinalCart)}
          >
            Make Payment
          </button>
        ) : (
          <button className="bttn-make-payment-grey" disabled>
            Make Payment
          </button>
        )}
      </div>
    </div>
  );
};
